export const SELECTOR_COLUMN_WIDTH = 50;
